import React, { useState, useEffect } from 'react'

import { makeSpotifyRequest, makeSpotifyPutRequest } from '../../config/SpotifyRequests'

import { useSpotify } from '../../hoc/context/SpotifyContextContainer'
import { GetPlayer } from '../../hoc/Layout/Layout'

import db from '../../config/firebase'
import Browse from './Browse'

import Loader from '../loader/Loader'
import Information from '../../widgets/information/Information'
import Error from '../../widgets/error/Error'

export default function BrowseContainer() {

    const { accessToken } = useSpotify()
    const { setModal } = GetPlayer()

    const ids = []

    const [ render, setRender ] = useState(false)
    const [items, setItems] = useState([])

    const follow = async (pid) => {
        try {

            (await makeSpotifyPutRequest(`https://api.spotify.com/v1/playlists/${pid}/followers`, {}, accessToken))
            setModal(<Information message="You are now following playlist" />)
        } catch(e){
             setModal(<Error message={`An error has occured : can't follow playlist!!!`} />)
        }
    }

    useEffect(async () => {

        try {

            const snapshop = await db.collection('DISCOVER_PLAYLISTS').get()
            snapshop.forEach((doc) => ids.push(doc.data().id));
            ids.forEach(async (id) => {
                let playlist = (await makeSpotifyRequest(`https://api.spotify.com/v1/playlists/${id}`, accessToken)).data
                playlist.first_track = playlist.tracks.items[0].track.id


                const tracksLink = playlist.tracks.href
                const tracks = (await makeSpotifyRequest(`${tracksLink}`, accessToken)).data.items

                playlist.tracks = tracks
                
                items.push(playlist)
                setItems([...items])
                setRender(true)
            })
        }catch(e){

        }
       
    }, [])

    return (
        <>  
            {render  &&  <Browse follow={follow} items={items} />}
            {!render  &&  <Loader />}
        </>
    )
}
